import React, { useEffect } from "react";

const COLOR_MAP = {
  light_red: "#FDE8E8",
  light_blue: "#E6F0FF",
  light_green: "#E8F8F1",
  light_yellow: "#FFF7E0",
  light_purple: "#F1E8FF",
  light_orange: "#FFEBDD",
  light_pink: "#FFE6F1",
  light_brown: "#F5EDE6",
  light_gray: "#F5F5F5",
  dark_red: "#D14343",
  dark_blue: "#1F4DB3",
  dark_green: "#2F855A",
  dark_yellow: "#B7791F",
  dark_purple: "#553C9A",
  dark_orange: "#C05621",
  dark_pink: "#B83280",
  dark_brown: "#8B5E3C",
  dark_gray: "#4A5568",
  none: "transparent",
};

const CircularOffersSlider = ({
  title,
  products,
  showTitle = true,
  backgroundColor,
}) => {
  useEffect(() => {
    // Wait for DOM to be ready and Swiper to be available
    const initializeSlider = () => {
      if (!window.Swiper) {
        console.log("Swiper not available yet, retrying...");
        setTimeout(initializeSlider, 100);
        return;
      }

      // Initialize CircularOffersSlider
      if (
        document.querySelector(".tf-sw-recent") &&
        !document.querySelector(".tf-sw-recent").swiper
      ) {
        console.log("Initializing CircularOffersSlider...");
        const sliderElement = document.querySelector(".tf-sw-recent");
        const preview = parseFloat(sliderElement.dataset.preview) || 6;
        const tablet = parseFloat(sliderElement.dataset.tablet) || 3;
        const mobile = parseFloat(sliderElement.dataset.mobile) || 3;
        const spacingLg = parseInt(sliderElement.dataset.spaceLg) || 70;
        const spacingMd = parseInt(sliderElement.dataset.spaceMd) || 30;
        const spacing = parseInt(sliderElement.dataset.space) || 15;
        const perGroup = parseInt(sliderElement.dataset.pagination) || 2;
        const perGroupMd = parseInt(sliderElement.dataset.paginationMd) || 3;
        const perGroupLg = parseInt(sliderElement.dataset.paginationLg) || 3;

        new window.Swiper(".tf-sw-recent", {
          slidesPerView: mobile,
          spaceBetween: spacing,
          speed: 1000,
          pagination: {
            el: ".sw-pagination-recent",
            clickable: true,
          },
          slidesPerGroup: perGroup,
          navigation: {
            clickable: true,
            nextEl: ".nav-next-recent",
            prevEl: ".nav-prev-recent",
          },
          breakpoints: {
            768: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupLg,
            },
            1150: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupLg,
            },
          },
        });
        console.log("CircularOffersSlider initialized successfully");
      }
    };

    initializeSlider();
  }, []);

  const resolvedBg =
    backgroundColor && COLOR_MAP[backgroundColor]
      ? COLOR_MAP[backgroundColor]
      : backgroundColor && /^#|rgb|hsl/.test(backgroundColor)
      ? backgroundColor
      : undefined;

  return (
    <>
      <style>
        {`
          /* Maximum width constraint for circular offers slider */
          #accessories-section.flat-spacing-27-edit {
            max-width: 1600px !important;
            margin: 0 auto !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
            box-sizing: border-box !important;
          }

          @media (max-width: 575px) {
            #accessories-section.flat-spacing-27-edit {
              max-width: 100% !important;
              padding-left: 12px !important;
              padding-right: 12px !important;
            }
          }

          @media (min-width: 576px) and (max-width: 767px) {
            #accessories-section.flat-spacing-27-edit {
              max-width: 100% !important;
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
          }

          @media (min-width: 768px) and (max-width: 991px) {
            #accessories-section.flat-spacing-27-edit {
              max-width: 1200px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 992px) and (max-width: 1199px) {
            #accessories-section.flat-spacing-27-edit {
              max-width: 1400px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 1400px) {
            #accessories-section.flat-spacing-27-edit {
              max-width: 1600px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          /* Blue hover effect for product titles */
          .collection-item-circle .collection-content .title {
            transition: color 0.3s ease;
          }
          
          .collection-item-circle:hover .collection-content .title {
            color: #0e5aa7 !important;
          }

          /* Align first slider item with title by matching container padding */
          #accessories-section .slider-layout-right.container-full {
            padding-left: 15px !important;
            padding-right: 0 !important;
          }

          /* Remove all padding/margin from wrapper elements */
          #accessories-section .flat-categories-bg,
          #accessories-section .wrap-carousel,
          #accessories-section .wrap-carousel-circularOffersSlider {
            padding-left: 0 !important;
            padding-right: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
          }

          #accessories-section .wrap-carousel-circularOffersSlider .swiper,
          #accessories-section .wrap-carousel-circularOffersSlider .swiper-wrapper,
          #accessories-section .wrap-carousel-circularOffersSlider .swiper-slide {
            padding-left: 0 !important;
            margin-left: 0 !important;
          }

          #accessories-section .wrap-carousel-circularOffersSlider .swiper-slide:first-child {
            margin-left: 0 !important;
            padding-left: 0 !important;
          }

          /* Ensure swiper starts at container padding position */
          #accessories-section .tf-sw-recent.sw-wrapper-right {
            margin-left: 0 !important;
            padding-left: 0 !important;
          }

          @media (min-width: 576px) {
            #accessories-section .slider-layout-right.container-full {
              padding-left: 20px !important;
            }
          }

          @media (min-width: 768px) {
            #accessories-section .slider-layout-right.container-full {
              padding-left: 30px !important;
            }
          }

          @media (min-width: 992px) {
            #accessories-section .slider-layout-right.container-full {
              padding-left: 40px !important;
            }
          }

          @media (min-width: 1200px) {
            #accessories-section .slider-layout-right.container-full {
              padding-left: 50px !important;
            }
          }

          /* Make items fit 3 per view on mobile with reduced spacing */
          @media (max-width: 575px) {
            #accessories-section .collection-item-circle {
              max-width: 100% !important;
              width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
            }

            #accessories-section .collection-item-circle .collection-image {
              width: 100px !important;
              height: 100px !important;
              margin: 0 auto !important;
              padding: 0 !important;
            }

            #accessories-section .collection-item-circle .collection-image img {
              width: 100% !important;
              height: 100% !important;
              object-fit: contain !important;
            }

            #accessories-section .collection-item-circle .collection-content {
              padding: 0 !important;
              margin: 0 !important;
              margin-top: 8px !important;
            }

            #accessories-section .collection-item-circle .collection-content .title {
              font-size: 12px !important;
              line-height: 1.2 !important;
              margin: 0 !important;
              padding: 0 !important;
            }

            #accessories-section .swiper-slide {
              display: flex !important;
              justify-content: center !important;
              padding: 0 !important;
              margin: 0 !important;
              width: calc((100% - 24px) / 3) !important;
              max-width: calc((100% - 24px) / 3) !important;
              box-sizing: border-box !important;
            }

            /* Ensure proper spacing between slides */
            #accessories-section .wrap-carousel-circularOffersSlider .swiper-wrapper {
              gap: 0 !important;
            }
          }
        `}
      </style>
      <section
        id="accessories-section"
        className="flat-spacing-27-edit"
        style={{ marginBottom: "40px", paddingTop: "60px" }}
      >
        <div className="container">
          <div
            className="flat-title flex-row justify-content-between px-0"
            style={{ marginBottom: "24px" }}
          >
            {showTitle && title && (
              <span
                className="title wow fadeInUp text_green-1"
                data-wow-delay="0s"
                style={{ fontSize: "1.6rem", fontWeight: "600" }}
              >
                {title}
              </span>
            )}
          </div>
        </div>
        <div className="container-full slider-layout-right">
          <div
            className="flat-categories-bg wrap-carousel wrap-carousel-circularOffersSlider"
            style={resolvedBg ? { backgroundColor: resolvedBg } : undefined}
          >
            <div
              dir="ltr"
              className="swiper tf-sw-recent wow fadeInUp sw-wrapper-right"
              data-preview="6"
              data-tablet="3"
              data-mobile="3"
              data-space-lg="70"
              data-space-md="30"
              data-space="12"
              data-pagination="2"
              data-pagination-md="3"
              data-pagination-lg="3"
            >
              <div className="swiper-wrapper">
                {products.map((product, index) => (
                  <div key={index} className="swiper-slide">
                    <div className="collection-item-circle hover-img">
                      <a
                        href={product.link || "/shop-collection-sub"}
                        className="collection-image img-style img-style-collection"
                      >
                        <img src={product.image} alt={product.name} />
                      </a>
                      <div className="collection-content text-center collection-content-before">
                        <a
                          href={product.link || "/shop-collection-sub"}
                          className="link title fw-5 text-line-clamp-1"
                          style={{ fontSize: "16px" }}
                        >
                          {product.name}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="sw-dots style-2 sw-pagination-recent justify-content-center"></div>
            </div>
            {/* <div className="nav-sw nav-next-slider nav-next-recent box-icon w_46 round">
            <span className="icon icon-arrow-left"></span>
          </div>
          <div className="nav-sw nav-prev-slider nav-prev-recent box-icon w_46 round">
            <span className="icon icon-arrow-right"></span>
          </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default CircularOffersSlider;
